import HostApi from "../../../../settings/HostApi";

// Los errores se propagan: el caso de uso revierte el corazón y manda `favorito_fallido`.
const LikeCarApiImpl = async (carId: string, like: boolean): Promise<void> => {
    if (like) await HostApi.post("/favorites/", { car_id: carId }, true);
    else await HostApi.remove(`/favorites/${carId}/`, true);
};

export default LikeCarApiImpl;
